import React, { Component } from 'react';
import Header from './Header';
import WhiteBoxHeader from './WhiteBoxHeader';
import WhiteBoxStats from './WhiteBoxStats';
import TimelineSelector from './TimelineSelector';
import Notification from './Notification';
import Incidents from './Incidents';
import ProtectedPage from './ProtectedPage';
import './App.scss';
import { getBaseUrl } from './utils';
import { withRouter } from 'react-router-dom';
import PoweredBy from './PoweredBy';

const baseUrl = getBaseUrl();
  
class App extends Component {
  constructor(props) {
    super(props);

    let showNotification = false;
    let notificationMessage = '';
    if (!!this.props.location.search) {
      const { search } = this.props.location;
      showNotification = search.includes('confirm=true') || search.includes('unsubscribe=true');
      
      if (search.includes('confirm=true')) {
        notificationMessage = 'You successfully confirmed your subscription to this status page';
      } else if (search.includes('unsubscribe=true')) {
        notificationMessage = 'You successfully unsubscribed to this status page';
      }
    }

    this.state = {
      statusPageId: null,
      environment: '',
      loading: false,
      services: [],
      statuspage: props.history.location.statuspage,
      timelineItems: [
        { value: 1, name: '24 hours'},
        { value: 8, name: '1 week'},
        { value: 31, name: '1 month'},
        { value: 91, name: '3 months'},
        { value: 365, name: '12 months'},
      ],
      selectedTimeline: 1,
      baseUrl,
      color: '',
      showNotification,
      notificationMessage,
      protected: false,
      protectedPageData: {},
      incidents: []
    };
  }

  componentDidMount() {
    const { pathname, hostname } = window.location;
    const statusPageId = pathname.split('/public/')[1];

    if (pathname.includes('/public/')) {
      this.setState({
        environment: 'preview',
        statusPageId
      }, () => this.fetchStatusPage());
    } else {
      this.setState({
        environment: 'live',
        statusPageId: hostname
      }, () => this.fetchStatusPage());
    }
  }

  isNumber(n) {
    return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
  } 

  hasFavicon() {
    return !!this.state.statuspage.favicon && this.state.statuspage.favicon.length
  }

  setFavicon() {
    let favicon = ''

    if (this.hasFavicon()) {
      favicon = this.state.statuspage.favicon 
    } else {
      const service = this.state.services.find((serv) => !!serv.favicon && serv.favicon.length)
      if (!!service && !!service.favicon) {
        favicon = service.favicon
      }
    }

    if (!!favicon && favicon.length) {
      document.querySelector("link[rel='shortcut icon']").href = favicon;
    }
  }

  setTabName() {
    document.title = (this.state.statuspage.name || 'System') + ' Status';
  }

  fetchSnapshots(services) {
    const ids = services.map(service => {
      if (service.isResponseTimeSelected || service.isUptimeSelected) {
        return service.id;
      }
    });

    ids.forEach((id) => {
      fetch(`${this.state.baseUrl}/api/v1/public/snapshots/${id}?limit=365`)
      .then((response) => response.json())
      .then((response) => response.data)
      .then((snapshots) => {
        const services = this.state.services.map((serv) => {
          if (serv.id === id) {
            serv.snapshots = snapshots;
          }
          return serv;
        });

        this.setState({ services });
      })
    });
  }

  fetchPreview() {
    const { statuspage } = this.state;
    if (!!statuspage) {
        this.setState({
          loading: false,
          services: [...statuspage.services],
          statuspage: statuspage,
          incidents: statuspage.incidents || []
        });
      this.fetchSnapshots(statuspage.services);
      this.setFavicon();
      this.setTabName();
      return;
    }

    // let tokenSession = localStorage.getItem('ngStorage-tokenSession')
    // if (!!tokenSession) {
    //   tokenSession = tokenSession.replace(/"/, '').replace(/"/, '');
    // }
    // const userId = localStorage.getItem('ngStorage-userId');

    fetch(`${this.state.baseUrl}/api/v1/public/services/${this.state.statusPageId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      credentials: 'include'
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.message === 'Unauthorized') {
          this.setState({ protected: true, protectedPageData: response.data });
        }
        return response;
      })
      .then((response) => response.data)
      .then((statuspage) => {
        this.setState({
          loading: false,
          services: [...statuspage.services],
          statuspage: statuspage,
          incidents: statuspage.incidents || []
        });

        this.fetchSnapshots(statuspage.services);
        this.setFavicon();
        this.setTabName();
      }).catch((err) => {
      });
  }

  fetchStatusPage() {
    this.setState({ loading: true });
    this.fetchPreview();
  }

  handleTimelineSelector = (value) => {
    const selectedTimeline = parseInt(value, 10);
    this.setState({ selectedTimeline });
  }

  hasSnapshotsLoaded() {
    const services = this.state.services;
    const servicesWithGraphs = services.filter(service => service.isResponseTimeSelected || service.isUptimeSelected);
    const hasSnapshots = servicesWithGraphs.every(service => !!service.snapshots);
    if (!hasSnapshots) {
      return false;
    }
    const hasLoaded = servicesWithGraphs.every(service => !!service.snapshots.length);
    return hasLoaded;
  }

  closeNotification = () => {
    this.setState({ showNotification: false });
  }

  hasAtLeastOneMetric = () => {
    if (!!this.state.services && this.state.services.length) {
      const hasAtLeastOne = this.state.services.find((service) => (service.isResponseTimeSelected || service.isUptimeSelected));
      return !!hasAtLeastOne;
    }

    return false;
  }

  render() {
    if (this.state.protected) {
      return (
        <ProtectedPage
          data={this.state.protectedPageData}
        />
      )
    }

    return (
      <div>
        {this.state.showNotification && <Notification closeNotification={this.closeNotification} message={this.state.notificationMessage} type="success" />}
        <Header statuspage={this.state.statuspage}/>

        {!!this.state.services.length &&
          <WhiteBoxHeader services={this.state.services} />
        }

        {!!this.state.services.length && this.hasAtLeastOneMetric() &&
          <TimelineSelector
            items={this.state.timelineItems}
            onClick={event => this.handleTimelineSelector(event)}
            selected={this.state.selectedTimeline}
            hasSnapshots={this.hasSnapshotsLoaded()}
          />
        }

        {!!this.state.services.length && !!this.state.statuspage &&
          <WhiteBoxStats
            services={this.state.services}
            selectedTimeline={this.state.selectedTimeline}
            color={this.state.statuspage.color} 
          />
        }

        {!!this.state.statuspage && this.state.statuspage.features && this.state.statuspage.features.incidents &&
          <Incidents
            statusPageId={this.state.statusPageId}
            isHomePage={true}
            incidents={this.state.incidents || []}
            features={this.state.statuspage.features}
            statuspage={this.state.statuspage} />
        }

        {!!this.state.services.length &&
          <div className="right-wrapper">
            <PoweredBy />
          </div>
        }
      </div>
    );
  }
}

export default withRouter(App);
